import { createContext, useState } from "react";
import api from "../api/axiosInstance.js";

export const HeaderContext = createContext();

export const HeaderProvider = ({ children }) => {
  const [headerData, setHeaderData] = useState("");


  const getHeaderData = async (roleId) => {
    try {
      const response = await api.get(`/api/users/user-data?roleId=${roleId}`);
      const data = response.data;
      setHeaderData(data);
    } catch (error) {
      console.log(error);
    }
  };

  return <HeaderContext.Provider value={{ headerData, getHeaderData }}>{children}</HeaderContext.Provider>;
};
